import { EMPTY_VALUE } from '@/constants/app.constants';
import { formatDisplayDateTime } from '@/utils/date';
import {
  PCMP_DISBURSEMENT_ACK_TONE,
  PCMP_DISBURSEMENT_CONFIRM_LABELS,
  PCMP_DISBURSEMENT_VERIFY_LABELS,
} from '../../constants/pcmpDisburseVerify.constants';
import type { PcmpPayoutAcks } from '../../types/pcmpProposal.types';
import { PcmpStatusPill } from '../PcmpProposalDetail/PcmpStatusPill';

type PcmpPayoutAckCellProps =
  | { kind: 'confirmation'; ack: PcmpPayoutAcks['confirmation'] }
  | { kind: 'verification'; ack: PcmpPayoutAcks['verification'] };

/** A queue cell: the MO's confirmation or MIS's verification, when, and its remarks. */
export function PcmpPayoutAckCell(props: PcmpPayoutAckCellProps) {
  const { ack } = props;
  if (!ack) return <span className="text-muted-foreground">{EMPTY_VALUE}</span>;
  const label =
    props.kind === 'confirmation'
      ? props.ack && PCMP_DISBURSEMENT_CONFIRM_LABELS[props.ack.status]
      : props.ack && PCMP_DISBURSEMENT_VERIFY_LABELS[props.ack.status];

  return (
    <div className="flex max-w-64 flex-col gap-0.5">
      <PcmpStatusPill tone={PCMP_DISBURSEMENT_ACK_TONE[ack.status]}>{label}</PcmpStatusPill>
      {ack.at ? (
        <span className="text-xs text-muted-foreground">{formatDisplayDateTime(ack.at)}</span>
      ) : null}
      {ack.remarks ? (
        <span className="truncate text-xs text-muted-foreground" title={ack.remarks}>
          {ack.remarks}
        </span>
      ) : null}
    </div>
  );
}
